<div class="dashboard-container p-2">
  <div class="applicant-top-actions d-flex justify-content-between align-items-center gap-2 px-1 mt-2">
    <button
      type="button"
      class="btn btn-sm border-0 rounded bg-transparent d-flex align-items-center fw-bold text-dark"
      @click="$router.push('/view_all_user_forms')"
      title="Go back to job posts"
    >
      <i class="bi bi-house fs-5 text-dark"></i>
      <span class="ms-2 text-xxs">Home</span>
    </button>

    <button
      type="button"
      class="btn btn-sm border-0 rounded bg-transparent d-flex align-items-center fw-bold text-dark"
      @click="logout_applicant"
      title="Log Out"
    >
      <i class="bi bi-box-arrow-right fs-5 text-dark"></i>
      <span class="ms-2 text-xxs">Logout</span>
    </button>
  </div>
  <!-- ── NAV CARDS ── -->
  <div class="row row-cols-2 g-2 mb-3 mb-md-4 mt-3 px-1">
    <!-- Profile -->
    <div class="col-md-6">
      <div
        class="card shadow border-0 h-100 text-center cursor-pointer rounded-3"
        :class="activeTab === 'profile' ? 'bg-gradient text-white' : 'bg-primary-dark bg-light text-white'"
        @click="activeTab = 'profile'"
      >
        <div class="card-body py-1 px-2">
          <i
            class="bi bi-person-circle fs-5 mb-1"
            :class="activeTab === 'profile' ? 'text-white' : 'text-white'"
          ></i>
          <p class="mb-0 text-xs fw-semibold">Profile</p>
          <small
            class="d-block lh-1"
            :class="activeTab === 'profile' ? 'text-white' : 'text-white'"
          >
            <span class="d-none" v-if="profile_completion_ready">{{ profile_completion }}% complete</span>
            <span v-else><i class="d-none bi bi-three-dots text-white-50"></i></span>
          </small>

        </div>
      </div>
    </div>

   <!-- Jobs -->
    <div class="col-md-6">
      <div
        class="card shadow border-0 h-100 text-center cursor-pointer rounded-3"
        :class="activeTab === 'jobs' ? 'bg-gradient text-white' : 'bg-primary-dark bg-light text-white'"
        @click="activeTab = 'jobs'"
      >
        <div class="card-body py-1 px-2">
          <i class="bi bi-briefcase fs-5 mb-1"></i>
          <p class="mb-0 text-xs fw-semibold">Jobs</p>
          <small
            class="d-block lh-1"
            :class="activeTab === 'jobs' ? 'text-white' : 'text-white'"
          >
            <!-- {{ stats.vacancies }} -->
          </small>
        </div>
      </div>
    </div>
  </div>

  <!-- ── PANEL AREA ── -->
  <div class="panel-area">
  <transition name="panel-fade" mode="out-in">
    <!-- PROFILE -->
    <div v-if="activeTab === 'profile'" key="profile" class="profile-panel-host applied-scroll-area shadow-lg p-2">
      <ProfileInfo @profile-completion="on_profile_completion_update" />
    </div>

      <!-- ── JOBS APPLIED TAB ── -->
    <div v-else-if="activeTab === 'jobs'" key="jobs" class="entity-tab-panel">
      <div class="applied-scroll-area">
        <!-- Mobile Filter (hidden on lg+) -->
        <div class="mobile-filter-card d-lg-none">
          <!-- Search -->
          <div class="mobile-search-bar">
            <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <circle cx="11" cy="11" r="8"/>
              <path d="m21 21-4.35-4.35"/>
            </svg>
            <input 
              type="text"
              placeholder="Search jobs or ref #"
              v-model="vacancy_filters.search"
              @input="on_vacancy_filter_change"
            />
          </div>

          <!-- Filter Tabs -->
          <div class="mobile-tabs">
            <button 
              v-for="tracker in application_tracker_tabs"
              :key="tracker.key"
              type="button"
              class="mobile-tab"
              :class="{ active: applicationTrackerTab === tracker.key }"
              @click="applicationTrackerTab = tracker.key"
            >
              <span class="num">{{ tracker.count }}</span>
              <span class="label">{{ tracker.label }}</span>
            </button>
          </div>
        </div>

        <!-- DESKTOP FILTER VIEW (hidden on mobile) -->
        <div class="shadow-lg glassy-table border-0 rounded-lg mb-3 desktop-filter-card">
          <div class="job-tracker-header d-flex flex-column flex-lg-row align-items-lg-center gap-2 p-3">
            <div class="job-tracker-header-main">
              <h6 class="job-tracker-title mb-0">Job Filter</h6>
            </div>

            <div class="job-tracker-tabs-row d-flex flex-wrap gap-2">
            <button
              v-for="tracker in application_tracker_tabs"
              :key="tracker.key"
              type="button"
              class="btn btn-sm rounded-pill d-inline-flex align-items-center gap-1 py-2 fw-600 text-xs border border-2"
              :class="applicationTrackerTab === tracker.key ? 'btn-primary-dark text-white' : 'bg-white text-dark'"
              @click="applicationTrackerTab = tracker.key"
            >
              <span>{{ tracker.label }} &middot; {{ tracker.count }}</span>
              <i v-if="tracker.dropdown" class="bi bi-chevron-down"></i>
            </button>
            <select
              v-model="vacancy_filters.datePosted"
              class="job-tracker-date-filter btn btn-sm rounded-pill px-3 py-2 fw-600 text-xs border border-2 bg-white text-dark"
              @change="on_vacancy_filter_change"
            >
              <option value="any_time">Any Time</option>
              <option value="past_24_hours">Past 24 Hours</option>
              <option value="past_week">Past Week</option>
              <option value="past_month">Past Month</option>
            </select>
          </div>
            <div class="job-tracker-search ms-lg-auto">
              <div class="input-group">
                <span class="input-group-text bg-white border border-1 shadow-sm">
                  <i class="bi bi-search text-muted vtf-search-icon"></i>
                </span>
                <input
                  v-model="vacancy_filters.search"
                  type="text"
                  class="form-control form-control-sm text-xs border border-2 shadow-sm"
                  placeholder="Search by job title or reference #"
                  @input="on_vacancy_filter_change"
                >
              </div>
          </div>
          </div>
        </div>

        <div v-if="is_applied_tracker_tab && has_approved_application" class="alert alert-info border-0 shadow-sm rounded-3 mb-3 d-flex align-items-center gap-2 text-xs">
          <i class="bi bi-info-circle-fill text-info fs-5 flex-shrink-0"></i>
          <p class="mb-0">
            You have <strong>{{ approved_count }} approved</strong>
            {{ approved_count === 1 ? 'application' : 'applications' }}. Check your emails for next steps.
          </p>
        </div>

        <!-- TABLE Desktop — DataTables owns the rows, tbody must stay empty -->
        <div v-if="is_all_jobs_tracker_tab && paginated_vacancies.length" class="vacancies-scroll-area mb-3">
          <div class="row row-cols-1 row-cols-md-2 g-2">
            <div v-for="(job, index) in paginated_vacancies" :key="job.id || `job-${index}`" class="col">
              <div class="glassy-table h-100 shadow-lg rounded-lg p-3 d-flex flex-column gap-1"
                :class="'vtf-status-' + (job.status || '').toLowerCase().replace(/\s+/g, '-')">
                <div class="d-flex align-items-start gap-1">
                  <div class="d-flex align-items-center justify-content-center job-icon p-1 flex-shrink-0">
                    <i class="bi bi-briefcase-fill fs-5 rounded-lg briefcase-green-icon"></i>
                  </div>

                  <div class="flex-grow-1">
                    <div class="d-flex justify-content-between align-items-start gap-1 mb-1">
                      <span class="fw-bold fw-600 text-x pe-2">{{ job.jobTitle }}</span>
                      <span class="status-badge text-dark fw-bold flex-shrink-0 border-0" :class="get_status_badge_class(job.status)">
                        {{ job.status }}
                      </span>
                    </div>

                    <p class="text-dark text-xs mb-1" v-if="job.referenceNumber && job.referenceNumber !== '-'">
                      <span class="fw-600">Ref :</span> {{ job.referenceNumber }}
                    </p>

                    <div class="text-dark text-xs d-flex flex-column gap-1">
                      <p class="mb-0">
                        <i class="bi bi-calendar-event me-1"></i>
                        <span v-if="job.publishedDate" class="fw-600"><span class="fw-bold">Opens :</span> {{ format_display_datetime(job.publishedDate) }}</span>
                        <span v-else>Opens : TBD</span>
                      </p>
                      <p class="mb-0">
                        <i class="bi bi-calendar-check me-1"></i>
                        <span v-if="job.closingDate" class="fw-600"><span class="fw-bold">Closes :</span> {{ format_display_datetime(job.closingDate) }}</span>
                        <span v-else>Open-ended</span>
                        <div class="d-flex justify-content-end mt-1">
                      <button
                        class="btn btn-primary btn-sm text-xxs"
                        data-bs-toggle="modal"
                        data-bs-target="#job-details-modal"
                        @click="open_job_details(job)"
                      >
                        View Details
                      </button>
                    </div>
                      </p>
                      
                    </div>

                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="is_applied_tracker_tab && filtered_applied_applications.length" class="vacancies-scroll-area mb-3">
          <div class="row row-cols-1 row-cols-md-2 g-2">
            <div v-for="(row, index) in filtered_applied_applications" :key="row['Application No'] || `app-${index}`" class="col">
              <div class="glassy-table h-100 shadow-lg rounded-lg p-3 d-flex flex-column gap-1"
                :class="'vtf-status-' + (row['Status'] || '').toLowerCase().replace(/\s+/g, '-')">
                <div class="d-flex align-items-start gap-1">
                  <div class="d-flex align-items-center justify-content-center job-icon p-1 flex-shrink-0">
                    <i class="bi bi-briefcase-fill fs-5 rounded-lg briefcase-green-icon"></i>
                  </div>

                  <div class="flex-grow-1">
                    <div class="d-flex justify-content-between align-items-start gap-1 mb-1">
                      <span class="fw-bold fw-600 text-x pe-2">{{ row['Job Advertised'] || row._entity_type_name || 'Job advert' }}</span>
                      <span class="status-badge text-dark fw-bold flex-shrink-0 border-0" :class="status_class(row['Status'])">
                        {{ row['Status'] }}
                      </span>
                    </div>

                    <p class="text-dark text-xs mb-1" v-if="row['Application No'] && row['Application No'] !== '-'">
                      <span class="fw-600">Ref :</span> {{ row['Application No'] }}
                    </p>

                    <div class="text-dark text-xs d-flex flex-column gap-1">
                      <p class="mb-0">
                        <i class="bi bi-calendar-event me-1"></i>
                        <span class="fw-600"><span class="fw-bold">Applied :</span> {{ row['Date Created'] }}</span>
                      </p>
                    </div>

                    <div class="d-flex justify-content-end gap-2 mt-2">
                      <button
                        class="btn btn-primary btn-sm text-xxs"
                        @click="view_entity_application_overview(
                          row._application_id, row['Status'],
                          row._entity_profile_id, row._entity_type_id, row._entity_name, row._entity_type_name
                        )"
                      >
                        View Details
                      </button>
                      <button
                        class="btn btn-primary-dark btn-sm text-xxs"
                        @click="withdraw_application(row._application_id)"
                      >
                        Withdraw
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ARCHIVED VACANCY CARDS -->
        <div v-if="is_archived_tracker_tab && filtered_archived_vacancies.length" class="vacancies-scroll-area mb-3">
          <div class="row row-cols-1 row-cols-md-2 g-2">
            <div v-for="(job, index) in filtered_archived_vacancies" :key="'arch-' + (job.id || index)" class="col">
              <div class="glassy-table h-100 shadow-lg rounded-lg p-3 d-flex flex-column gap-1"
                :class="'vtf-status-' + (job.status || '').toLowerCase().replace(/\s+/g, '-')">
                <div class="d-flex align-items-start gap-1">
                  <div class="d-flex align-items-center justify-content-center job-icon p-1 flex-shrink-0">
                    <i class="bi bi-briefcase-fill fs-5 rounded-lg briefcase-green-icon"></i>
                  </div>
                  <div class="flex-grow-1">
                    <div class="d-flex justify-content-between align-items-start gap-1 mb-1">
                      <span class="fw-bold fw-600 text-x pe-2">{{ job.jobTitle }}</span>
                      <span class="status-badge text-dark fw-bold flex-shrink-0 border-0" :class="get_status_badge_class(job.status)">
                        {{ job.status }}
                      </span>
                    </div>
                    <p class="text-dark text-xs mb-1" v-if="job.referenceNumber && job.referenceNumber !== '-'">
                      <span class="fw-600">Ref :</span> {{ job.referenceNumber }}
                    </p>
                    <div class="text-dark text-xs d-flex flex-column gap-1">
                      <p class="mb-0">
                        <i class="bi bi-calendar-event me-1"></i>
                        <span v-if="job.publishedDate" class="fw-600"><span class="fw-bold">Opens :</span> {{ format_display_datetime(job.publishedDate) }}</span>
                        <span v-else>Opens : TBD</span>
                      </p>
                      <p class="mb-0">
                        <i class="bi bi-calendar-check me-1"></i>
                        <span v-if="job.closingDate" class="fw-600"><span class="fw-bold">Closes :</span> {{ format_display_datetime(job.closingDate) }}</span>
                        <span v-else>Open-ended</span>
                      </p>
                    </div>
                    <div class="d-flex justify-content-end mt-2">
                      <button
                        class="btn btn-primary btn-sm text-xxs"
                        data-bs-toggle="modal"
                        data-bs-target="#job-details-modal"
                        @click="open_job_details(job)"
                      >View Details</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- WITHDRAWN CARDS -->
        <div v-if="is_withdrawn_tracker_tab && filtered_withdrawn_applications.length" class="vacancies-scroll-area mb-3">
          <div class="row row-cols-1 row-cols-md-2 g-2">
            <div v-for="(row, index) in filtered_withdrawn_applications" :key="'w-' + (row['Application No'] || index)" class="col">
              <div class="glassy-table h-100 shadow-lg rounded-lg p-3 d-flex flex-column gap-1 vtf-withdrawn-card"
                :class="'vtf-status-' + (row['Status'] || 'Withdrawn').toLowerCase().replace(/\s+/g, '-')">
                <div class="d-flex align-items-start gap-1">
                  <div class="d-flex align-items-center justify-content-center job-icon p-1 flex-shrink-0">
                    <i class="bi bi-briefcase-fill fs-5 rounded-lg briefcase-green-icon"></i>
                  </div>

                  <div class="flex-grow-1">
                    <div class="d-flex justify-content-between align-items-start gap-1 mb-1">
                      <span class="fw-bold fw-600 text-x pe-2">{{ row['Job Advertised'] || row._entity_type_name || 'Job advert' }}</span>
                      <span class="status-badge text-dark fw-bold flex-shrink-0 border-0 badge-secondary">
                        {{ row['Status'] || 'Withdrawn' }}
                      </span>
                    </div>

                    <p class="text-dark text-xs mb-1" v-if="row['Application No'] && row['Application No'] !== '-'">
                      <span class="fw-600">Ref :</span> {{ row['Application No'] }}
                    </p>

                    <div class="text-dark text-xs d-flex flex-column gap-1">
                      <p class="mb-0">
                        <i class="bi bi-calendar-event me-1"></i>
                        <span class="fw-600"><span class="fw-bold">Applied :</span> {{ row['Date Created'] }}</span>
                      </p>
                    </div>

                    <p class="text-muted text-xxs mt-2 mb-0">
                      This application has been withdrawn and can no longer be edited or viewed.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="(is_all_jobs_tracker_tab && vacancies.length && !filtered_vacancies.length) || (is_applied_tracker_tab && table_safe_application_list.length && !filtered_applied_applications.length)" class="job-tracker-shell card border-0 shadow-sm rounded-4 mb-3">
          <div class="job-tracker-empty-state">
            <i class="bi bi-search fs-1 text-muted mb-3 d-block"></i>
            <h5 class="job-tracker-empty-title mb-2">No jobs match your filters</h5>
            <p class="job-tracker-empty-copy mb-4">Try adjusting your search criteria.</p>
            <button type="button" class="job-tracker-cta" @click="clear_vacancy_filters">
              Clear Filters
            </button>
          </div>
        </div>

        <nav v-if="is_all_jobs_tracker_tab && vacancy_total_pages > 1" class="d-flex justify-content-center py-2" aria-label="Vacancies pagination">
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" :class="{ disabled: vacancy_current_page === 1 }">
              <a class="page-link" href="#" @click.prevent="vacancy_current_page > 1 && (vacancy_current_page--)">&lsaquo;</a>
            </li>
            <li class="page-item" v-for="page in vacancy_total_pages" :key="page" :class="{ active: vacancy_current_page === page }">
              <a class="page-link" href="#" @click.prevent="vacancy_current_page = page">{{ page }}</a>
            </li>
            <li class="page-item" :class="{ disabled: vacancy_current_page === vacancy_total_pages }">
              <a class="page-link" href="#" @click.prevent="vacancy_current_page < vacancy_total_pages && (vacancy_current_page++)">&rsaquo;</a>
            </li>
          </ul>
        </nav>

        <div v-if="(is_all_jobs_tracker_tab && !vacancies.length) || (is_archived_tracker_tab && !filtered_archived_vacancies.length) || (is_withdrawn_tracker_tab && !filtered_withdrawn_applications.length) || (!is_all_jobs_tracker_tab && !is_applied_tracker_tab && !is_archived_tracker_tab && !is_withdrawn_tracker_tab) || (is_applied_tracker_tab && !filtered_applied_applications.length)" class="job-tracker-shell card border-0 shadow-sm rounded-4">
          <div class="job-tracker-empty-state rounded-lg">
            <div class="" aria-hidden="true">
              <i class="bi bi-briefcase-fill fs-1 briefcase-green-icon"></i>
            </div>
            <h5 class="job-tracker-empty-title mb-2">{{ tracker_empty_state_title }}</h5>
            <p class="job-tracker-empty-copy mb-4">{{ tracker_empty_state_message }}</p>
          </div>
        </div>

      </div><!-- /applied-scroll-area -->
    </div>
  </transition>
  </div>
  <AICampusFooter v-if="activeTab !== 'profile'" />
</div>

<!-- Job Details Modal -->
<teleport to="body">
  <div class="modal fade" id="job-details-modal" tabindex="-1" aria-labelledby="job_details_label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg">

        <!-- Modal Header (cute-header like manage_questions) -->
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <div class="flex-grow-1">
            <p class="modal-title text-white text-xxs mb-0" id="job_details_label">{{ job_profile.title || job.title }}</p>
            <small class="text-white-50 text-xxs d-flex align-items-center flex-wrap gap-1" v-if="job.publishedDate || job.closingDate">
              <span v-if="job.departmentName" class="me-1">{{ job.departmentName }} &middot;</span>
              <i class="bi bi-calendar-event"></i>
              <span v-if="job.publishedDate">{{ format_display_datetime(job.publishedDate) }}</span>
              <span v-else>TBD</span>
              <span class="mx-1">to</span>
              <i class="bi bi-calendar-event"></i>
              <span v-if="job.closingDate">{{ format_display_datetime(job.closingDate) }}</span>
              <span v-else>Open-ended</span>
            </small>
            <small v-else class="text-white-50 text-xxs">{{ job.departmentName }} &middot; {{ job.recruitingPeriod }}</small>
          </div>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <!-- Modal Body (scrollable) -->
        <div class="modal-body p-4">

          <!-- Loading State -->
          <div v-if="loading_profile" class="text-center py-5">
            <div class="spinner-border text-primary" role="status"></div>
            <p class="mt-3 text-muted text-xxs">Loading job profile...</p>
          </div>

          <!-- Loaded Content (mirrors ViewJobProfile VIEW mode) -->
          <div v-else-if="job_profile.display_blocks && job_profile.display_blocks.length">

            <div v-for="(block, bidx) in job_profile.display_blocks" :key="block.key || bidx" class="job-detail-block">
              <div class="d-flex align-items-center mb-3">
                <span class="badge bg-green-gov-dark rounded-50 me-2 d-flex align-items-center justify-content-center circle-badge-28">
                  {{ block.title ? block.title.charAt(0) : 'A' }}
                </span>
                <h6 class="fw-bold mb-0 text-xs">{{ block.title }}</h6>
              </div>

              <div v-if="block.kind === 'details'" class="text-xxs text-dark rich-text-content job-detail-content">
                <component :is="parse_plain_text_list(block.data)?.tag || 'div'"
                           v-if="parse_plain_text_list(block.data)"
                           class="job-detail-list">
                  <li v-for="(item, idx) in parse_plain_text_list(block.data).items"
                      :key="'bdl-'+idx">
                    {{ item }}
                  </li>
                </component>
                <div v-else v-html="render_block_html(block, block.data)"></div>
              </div>

              <template v-else>
                <div v-if="block.data.table && block.data.table.rows && block.data.table.rows.length > 0 && has_table_content(block.data)"
                     class="table-responsive mb-3">
                  <table class="table table-bordered table-hover table-sm align-middle">
                    <thead class="table-light">
                      <tr>
                        <th v-for="(hdr, hIdx) in block.data.table.headers"
                            :key="'mh-'+hIdx"
                            class="fw-semibold text-xxs text-uppercase">
                          {{ typeof hdr === 'object' ? hdr.label : hdr }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, rIdx) in block.data.table.rows" :key="'mr-'+rIdx">
                        <td v-for="(cell, cIdx) in row"
                            :key="'mc-'+cIdx"
                            class="text-xxs rich-text-content job-detail-content">
                          <component :is="parse_plain_text_list(cell)?.tag || 'div'"
                                     v-if="parse_plain_text_list(cell)"
                                     class="job-detail-list">
                            <li v-for="(item, idx) in parse_plain_text_list(cell).items"
                                :key="'mcl-'+rIdx+'-'+cIdx+'-'+idx">
                              {{ item }}
                            </li>
                          </component>
                          <div v-else v-html="render_block_html(block, cell)"></div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div v-else-if="is_competencies_block(block) && block.data.descriptions && block.data.descriptions.length">
                  <div v-for="(desc, dIdx) in block.data.descriptions"
                       :key="'mcg-'+dIdx"
                       class="mb-2 text-xxs text-dark rich-text-content job-detail-content">
                    <template v-if="parse_competency_groups(desc).length">
                      <div v-for="(group, gIdx) in parse_competency_groups(desc)"
                           :key="'mcgg-'+dIdx+'-'+gIdx"
                           class="competency-group">
                        <p class="competency-line"><strong>{{ group.label }}:</strong></p>
                        <ul v-if="group.items.length > 1" class="competency-list">
                          <li v-for="(item, iIdx) in group.items"
                              :key="'mcgi-'+dIdx+'-'+gIdx+'-'+iIdx">
                            {{ item }}
                          </li>
                        </ul>
                        <p v-else class="competency-line">{{ group.value }}</p>
                      </div>
                    </template>
                    <component :is="parse_plain_text_list(desc)?.tag || 'div'"
                               v-else-if="parse_plain_text_list(desc)"
                               class="job-detail-list">
                      <li v-for="(item, idx) in parse_plain_text_list(desc).items"
                          :key="'mcdl-'+dIdx+'-'+idx">
                        {{ item }}
                      </li>
                    </component>
                    <div v-else v-html="render_block_html(block, desc)"></div>
                  </div>
                </div>

                <div v-else-if="block.data.descriptions && block.data.descriptions.length">
                  <div v-for="(desc, dIdx) in block.data.descriptions"
                       :key="'md-'+dIdx"
                       class="mb-2 text-xxs text-dark rich-text-content job-detail-content">
                    <component :is="parse_plain_text_list(desc)?.tag || 'div'"
                               v-if="parse_plain_text_list(desc)"
                               class="job-detail-list">
                      <li v-for="(item, idx) in parse_plain_text_list(desc).items"
                          :key="'mdl-'+dIdx+'-'+idx">
                        {{ item }}
                      </li>
                    </component>
                    <div v-else v-html="render_block_html(block, desc)"></div>
                  </div>
                </div>

                <div v-else-if="block.data.content" class="text-xxs text-dark rich-text-content job-detail-content">
                  <component :is="parse_plain_text_list(block.data.content)?.tag || 'div'"
                             v-if="parse_plain_text_list(block.data.content)"
                             class="job-detail-list">
                    <li v-for="(item, idx) in parse_plain_text_list(block.data.content).items"
                        :key="'mct-'+idx">
                      {{ item }}
                    </li>
                  </component>
                  <div v-else v-html="render_block_html(block, block.data.content)"></div>
                </div>

                <div v-else class="text-dark text-xxs fst-italic">
                  <i class="bi bi-info-circle me-1"></i>
                  No content available for this section.
                </div>
              </template>
            </div>

          </div>

          <!-- Fallback: No profile data -->
          <div v-else class="text-center py-5">
            <i class="bi bi-file-earmark-x fs-1 text-muted mb-3 d-block"></i>
            <p class="text-muted text-xxs mb-0">No advert data available for this position.</p>
          </div>

        </div>

        <!-- Modal Footer -->
        <div class="modal-footer border-0 p-2 d-flex justify-content-end">
          <button
            type="button"
            class="btn btn-sm rounded-small text-xxs shadow text-dark px-3"
            :class="job.alreadyApplied ? 'btn-secondary disabled' : 'btn-primary-dark'"
            :disabled="job.alreadyApplied || opening_application"
            @click="job.alreadyApplied ? null : applyForJob()"
          >
            {{ get_job_action_label(job) }}
          </button>
        </div>

      </div>
    </div>
  </div>
</teleport>

